export default __webpack_public_path__ + "f4c94eca816bc55682b18baf87be7530.svg";